<template>
  <b-card body>
    <div>
      <div class="d-flex align-items-start gap-[16px] mb-[16px]">
        <b-button
          variant="primary"
          size="sm"
          class="rounded-lg p-0"
          @click="$router.go(-1)"
        >
          <feather-icon
            size="2x"
            icon="ChevronLeftIcon"
          />
        </b-button>
        <div class="text-black font-semibold text-2xl">
          Data Inbound
        </div>
      </div>

      <div class="flex gap-[16px] justify-end">
        <div class="search-container max-w-[300px] w-full">
          <infinite-select
            v-model="partner"
            placeholder="Nama Partner"
            option-label="name"
            default-value=""
            :options="list_partner"
            :has-next-page="hasNextPartners"
            :reduce="partner => partner.id"
            :debounce-timeout="500"
            :loading="loadingPartner"
            :clearable="false"
            @on-search="searchPartners"
            @on-intersect="getPartner"
            @on-close="resetSelectionPartner"
          >
            <template #open-indicator="{ attributes }">
              <span
                v-bind="attributes"
                class="k-search-normal-1 text-[16px] !transform-none"
              />
            </template>
            <template #optionValue="{value}">
              {{ value.name }}
              <span
                v-if="value.unsubscribe === 1"
                class="ml-1 unsubscribe-tag"
              >Unsubscribe</span>
            </template>
          </infinite-select>
        </div>
        <v-select
          v-model="status"
          placeholder="Status Inbound"
          :options="filters"
          :clearable="false"
          label="text"
          class="max-w-[200px] w-full"
          :reduce="status => status.value"
        />
      </div>
    </div>
    <b-overlay
      :show="loading"
      spinner-variant="primary"
      variant="light"
      blur="0"
      opacity=".5"
      rounded="sm"
    >
      <b-table
        id="table"
        show-empty
        empty-text="Tidak ada data yang ditampilkan."
        class="mt-2 text-center"
        :fields="fields"
        :items="items"
        responsive
      >
        <template #cell(inbound_date)="data">
          <div>
            <div>{{ formatDate(data.item.inbound_date) }}</div>
          </div>
        </template>
        <template
          #cell(partner_name)="data"
        >
          <div class="d-flex">
            <span class="d-flex align-center">
              <b-avatar
                style="width: 40px; height: 40px;"
                rounded="circle"
                :src="data.item.image_logo_url"
              />
            </span>
            <span class="text-start ml-1">
              <div class="font-semibold">{{ data.item.partner_name }}</div>
              <div class="text-[#626262]">{{ data.item.city_name }}</div>
            </span>
          </div>
        </template>
        <template #cell(shipping)="data">
          <div
            v-if="data.item.is_retur === 0"
            class="flex gap-[10px]"
          >
            <img
              v-if="data.item.shipping || data.item.shipping_type.startsWith('lainnya-')"
              src="https://storage.googleapis.com/komerce/assets/menggunakan-ekspedisi-orange.svg"
              alt="dikirim"
            >
            <img
              v-else
              src="https://storage.googleapis.com/komerce/assets/dikirim-sendiri-orange.svg"
              alt="dikirim"
            >
            <div class="text-capitalize w-36">
              <div v-if="data.item.shipping">
                <span>Ekspedisi</span>
                <br>
                <span class="text-[#626262]">({{ data.item.shipping }})</span>
              </div>
              <div v-else>
                <span>{{ data.item.shipping_type.replace('lainnya-', '') }}</span>
              </div>
              <!-- {{ data.item.shipping ? data.item.shipping : data.item.shipping_type.replace('lainnya-', '') }} -->
            </div>
          </div>
          <div
            v-else
            class="flex gap-[10px]"
          >
            <img
              src="https://storage.googleapis.com/komerce/assets/komerce-icon/Orange/box-remove.svg"
              alt="retur"
            >
            <div class="w-36">
              Retur
            </div>
          </div>
        </template>
        <template #cell(no_resi)="data">
          <div v-if="data.item.no_resi === '' || data.item.no_resi === null">
            -
          </div>
          <div v-else>
            {{ data.item.no_resi }}
          </div>
        </template>
        <template #cell(status)="data">
          <inbound-status-pill
            :value="data.item.status"
          />
        </template>
        <template #cell(action)="data">
          <div
            class="underline text-capitalize"
            style="color: #08A0F7"
            type="button"
            @click="lihatDetail(data.item)"
          >
            Lihat Detail
          </div>
        </template>
      </b-table>
    </b-overlay>
  </b-card>
</template>

<script>
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import provider from '@/provider/provider'
import { INBOUND, SELECT_PARTNERS } from '@/provider/url'
import moment from 'moment'
import vSelect from 'vue-select'
import { SLASHED_DDMMYYYY } from '@/libs/filterDate'
import secureLocalStorage from '@/libs/secureLocalstorage'
import InfiniteSelect from '@/views/components/select/InfiniteSelect.vue'
import { toastError } from '@/libs/toastification'
import { fieldListInbound } from './config'
import InboundStatusPill from './InboundStatusPill.vue'

export default {
  components: {
    vSelect,
    InfiniteSelect,
    InboundStatusPill,
  },
  data() {
    return {
      SLASHED_DDMMYYYY,
      loading: false,
      loadingPartner: true,
      items: [],

      // filter
      status: '',
      partner: '',

      // infinite scroll
      limit: 50,
      offset: 0,
      lastData: false,

      list_partner: [
        {
          id: '',
          name: 'Semua Partner',
        },
      ],
      filters: [
        {
          value: '',
          text: 'Semua Status',
        },
        {
          value: 1,
          text: 'Proses',
        },
        {
          value: 2,
          text: 'Selesai',
        },
        {
          value: 3,
          text: 'Dibatalkan',
        },
      ],
      fields: fieldListInbound,
      hasNextPartners: false,
      limitPartners: 50,
      offsetPartners: 0,
      searchTermPartners: '',
    }
  },
  watch: {
    status(value) {
      if (!Number.isNaN(value) && this.$route.query.status !== String(value)) {
        this.$router.push({ query: { ...this.$route.query, status: value } }).catch(() => {})
      }
      this.getData()
    },
    partner(value) {
      if (this.$route.query.partner !== String(value)) {
        this.$router.push({ query: { ...this.$route.query, partner: value } }).catch(() => {})
      }
      this.getData()
    },
  },

  created() {
    this.getData()
    this.getPartner()
  },

  mounted() {
    if (this.$route.query.status && this.$route.query.status !== '0') {
      this.status = Number(this.$route.query.status)
    }
    window.onscroll = () => {
      if ((window.innerHeight + window.scrollY) >= document.getElementById('table').offsetHeight && !this.loading) {
        this.getNextData()
      }
    }
  },

  methods: {
    async getData() {
      this.offset = 0
      this.loading = true
      const params = `status=${this.status}&partner_id=${this.partner}&limit=${this.limit}&offset=${this.offset}`
      await provider
        .single(`${INBOUND}?${params}`)
        .then(response => {
          const { data } = response
          this.items = data
          this.offset = data.length
          if (data.length < this.limit) {
            this.lastData = true
          } else {
            this.lastData = false
          }
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: 'Gagal',
                icon: 'AlertCircleIcon',
                text: 'Gagal load data, silahkan coba lagi',
                variant: 'danger',
              },
              timeout: 2000,
            },
          )
        })
    },

    async getNextData() {
      if (!this.lastData) {
        this.loading = true
        const params = `status=${this.status}&partner_id=${this.partner}&limit=${this.limit}&offset=${this.offset}`
        await provider
          .single(`${INBOUND}?${params}`)
          .then(response => {
            const { data } = response
            this.items.push(...data)
            this.offset += data.length
            if (data.length < this.limit) {
              this.lastData = true
            }
            this.loading = false
          })
          .catch(error => {
            this.loading = false
            toastError('Gagal mengambil data inbound, silahkan coba lagi')
          })
      }
    },

    lihatDetail(data) {
      const { id } = data
      secureLocalStorage.set('dataInbound', JSON.stringify(data))
      this.$router.push(`/data-inbound/detail/${id}`)
    },
    searchPartners(q) {
      if (!q) {
        this.resetSelectionPartner()
      }
      this.getPartner(q)
    },
    resetSelectionPartner() {
      this.searchTermPartners = ''
      this.offsetPartners = 0
    },
    getPartner(q) {
      if (q) {
        this.offsetPartners = 0
        this.searchTermPartners = q
      }
      provider
        .single(`${SELECT_PARTNERS}?limit=${this.limitPartners}&offset=${this.offsetPartners}&search=${this.searchTermPartners}`)
        .then(response => {
          const { data } = response
          this.loadingPartner = false
          this.hasNextPartners = data.length >= this.limitPartners
          if (q && data.length === 0) {
            this.list_partner = []
            return
          }
          if (this.offsetPartners === 0 || q) {
            this.list_partner = [{
              id: '',
              name: 'Semua Partner',
            },
            ...data]
            this.offsetPartners += this.limitPartners
            if (this.$route.query.partner) {
              this.partner = Number(this.$route.query.partner)
            }
            return
          }
          this.list_partner.push(...data)
          this.offsetPartners += this.limitPartners
        }).catch(() => {
          toastError('Gagal mengambil daftar partner. Silakan coba lagi nanti.')
          this.loadingPartner = false
          if (q) this.list_partner = []
          else {
            this.list_partner = [{
              id: '',
              name: 'Semua Partner',
            }]
          }
          this.hasNextPartners = false
        })
    },
    formatDate(value) {
      return moment(value).format('DD MMMM YYYY')
    },
  },
}
</script>

<style lang="scss">
@import '~@core/scss/vue/libs/vue-select.scss';

.vs__dropdown-menu {
  max-height: 170px;
}

.unsubscribe-tag {
  border-radius: 4px;
  border: 1px solid currentColor;
  background: transparent;

  padding: 2px 6px;
  color: currentColor
}
</style>

<style scoped>
.search-container {
  .vs__dropdown-toggle {
    flex-direction: row-reverse;
  }
}
</style>
